import { post } from "../client/client";
import { endpoint } from "../endpoint";
import type { LoginRequest, LoginResponse } from "../type/auth";

export const userLogin = async (payload: LoginRequest) => {
  return post<LoginResponse, URLSearchParams>(
    endpoint.login,
    new URLSearchParams({
      username: payload.username,
      password: payload.password,
    }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const userLogout = async () => {
  return await post(endpoint.logout);
};
